import constants from "../../constants";
import dateUtils from "../../dateUtils";

export default {

  data() {
    return {
      incomingDateRange: null,
      fromIncomingDate: null,
      toIncomingDate: null,
      advanceSearchForm: {},
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    filterStatusQuery() {
      return this.$route.query.filterStatus;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    filterStatusQuery(newValue) {
      if (
        (newValue || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL) !==
        (this.filterStatus || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL)
      ) {
        this.advanceSearchForm.filterStatus = this.filterStatus = newValue
        this.doSearch();
      }
    }
  },

  // created() {
  //   this.initQuery();
  // },

  methods: {
    // filterByIncomingDateRange() {
    //   this.advanceSearchForm.fromIncomingDate =
    //     this.incomingDateRange && this.incomingDateRange[0]
    //       ? this.incomingDateRange[0].getTime()
    //       : undefined;
    //   this.advanceSearchForm.toIncomingDate =
    //     this.incomingDateRange && this.incomingDateRange[1]
    //       ? this.incomingDateRange[1].getTime()
    //       : undefined;
    //   this.doSearch();
    // },

    initIncomingDateRange() {
      if (
        this.advanceSearchForm.fromIncomingDate ||
        this.advanceSearchForm.toIncomingDate
      ) {
        this.incomingDateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromIncomingDate),
          dateUtils.toMoment(this.advanceSearchForm.toIncomingDate)
        ];
      } else {
        this.incomingDateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        this.advanceSearchForm.fromIncomingDate = defaultTimeRange[0];
        this.advanceSearchForm.toIncomingDate = defaultTimeRange[1];
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-in/vbDenVTMixin.js